<template>
  <div class="win-list-wrap">
    <div class="win-list-box">
      <div class="title-wrap">
        <!-- <i class="left"></i> -->
        <!-- <h3>中奖名单</h3> -->
        <img class="tit" src="../../assets/images/prize_tit.png" alt="">
        <!-- <i class="right"></i> -->
      </div>
      <div class="list-scroll" :class="{empty : winList.length == 0}">
        <div class="list-wrap">
          <vue-seamless-scroll :data="winList" :class-option="optionSetting" v-if="winList && winList.length>0">
            <dl v-if="winList.length>0">
              <dd v-for="(item,index) in winList" :key="index">
                <p>

                  <span class="img"><img :src="item.photo_url" v-if="item.photo_url" /><img v-else src="../../assets/images/userdefault.jpg" /></span>
                  <span class="n">恭喜{{item.loginName}}</span>
                  <span>奖品</span>
                  <span class="p point">{{item.bonus_desc}}</span>
                </p>
              </dd>
            </dl>
          </vue-seamless-scroll>
          <div class="no-win" v-else>
              <span class="icon"><img src="../../assets/images/nowinlist.png" alt=""></span>
              <p class="txt">暂无中奖名单</p>
              <p class="txt">期待你中奖上榜哦～</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vueSeamlessScroll from 'vue-seamless-scroll';

export default {
  name: 'winList',
  components: {
    vueSeamlessScroll,
  },
  props: ['winList'],
  computed: {
    optionSetting() {
      return {
        step: 0.6, // 数值越大速度滚动越快
        limitMoveNum: 7, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: false, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  data() {
    return {
      data: new Array(15),
    };
  },
  mounted() {
    // this.winList = [];
  },
};
</script>
<style lang="stylus">
.win-list-wrap {
  .win-list-box {
    width: 339px;
    // height: 442px;
    margin: 30px auto 0;
    border-radius: 8px;
    padding-top 15px
    .empty{
      background:rgba(255,255,255,.3);
    }
    .list-scroll {
      width: 309px;
      height: 365px;
      margin: 0 auto 20px;
      border-radius: 6px;
      .list-wrap {
        overflow: hidden;
        height: 100%;
        pointer-events: none;
        dl{
          p {
            height: 34px;
            white-space: nowrap;
            overflow: hidden;
            // text-overflow: ellipsis;
            padding: 10px;
            align-items: center;
            display: flex;
            font-weight: bold;
            text-align right;
            span {
              display: inline-block;
              color: #fff ;
              font-size: 14px;
              &.img {
                width: 32px;
                height: 32px;
                border-radius: 50%;
                overflow: hidden;
                border: 1px solid #fff;
                margin-right: 20px;
                vertical-align: middle;
                img{
                  width:100%;
                }
              }
              &.n {
                margin-right: 10px;
                color:#fff;
                width: 130px;
                text-align left;
              }
              &.p {
                margin-left: 10px;
                overflow: hidden;
                text-overflow: ellipsis;
                flex: 1;
                color: #F0A500 !important;
              }
            }
          }
        }
        .no-win{
          height: 100%;
          width: 100%;
          display: flex;
          justify-content: center;
          text-align: center;
          flex-direction:column;
          align-items: center;
          .icon{
            width:64px;
            height: 65px;
            display: block;
            margin-bottom: 15px;
            img{
              width:100%;
              height: 100%;
            }
          }
          .txt{
            display: block;
            font-size: 13px;
            color: #fff;
            padding-top: 5px;
          }
        }
      }
    }
  }
}
</style>
